import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.FETCH_SUGGEST_BOX_SIZES.REQUEST, saga.fetchSuggestBoxSizes);
    yield takeLatest(ACTION.GET_SUGGESTS_BY_VOLUME.REQUEST, saga.getSuggestsByVolume);
}
